// extracted by mini-css-extract-plugin
export var previewContainer = "_sx-0";